import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuditLogsListComponent } from './audit-logs-list/audit-logs-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: AuditLogsListComponent,
        data: {
          title: 'Audit Logs'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuditLogsRoutingModule {
}
